import fetch from '../utils/fetch'

// 获取订单送礼商品列表
export function getGiftordergoodsList(query) {
  return '/giftingordergoods/list'
}

// 添加送礼商品
export function getGiftordergoods(query) {
  return fetch({
    url: '/giftingordergoods',
    method: 'post',
    data: query
  })
}

// 删除送礼商品
export function deleteGiftordergoods(query) {
  return fetch({
    url: '/giftingordergoods',
    method: 'delete',
    params: query
  })
}

// 设置送礼设置
export function postGiftordersetting(query) {
  return fetch({
    url: '/giftingordersetting',
    method: 'post',
    data: query
  })
}

// 获取送礼设置
export function getGiftordersetting(query) {
  return fetch({
    url: '/giftingordersetting',
    method: 'get',
    data: query
  })
}

// 添加祝福语分类
export function getGiftorderblessingGroup(query) {
  return fetch({
    url: '/giftingorderblessing/group',
    method: 'post',
    data: query
  })
}

// 获取所有祝福语
export function getGiftorderblessingList(query) {
  return fetch({
    url: '/giftingorderblessing/list',
    method: 'get',
    data: query
  })
}

// 添加祝福语
export function getAddGiftorderblessing(query) {
  return fetch({
    url: '/giftingorderblessing',
    method: 'post',
    data: query
  })
}

// 修改祝福语分组
export function putGiftingorderblessingGroup(query) {
  return fetch({
    url: '/giftingorderblessing/group',
    method: 'put',
    data: query
  })
}

// 删除祝福语分组
export function deleteGiftingorderblessingGroup(query) {
  return fetch({
    url: '/giftingorderblessing/group',
    method: 'delete',
    params: query
  })
}

// 修改祝福语
export function editGiftingorderblessingGroup(query) {
  return fetch({
    url: '/giftingorderblessing',
    method: 'put',
    data: query
  })
}

// 删除祝福语
export function delGiftingorderblessing(query) {
  return fetch({
    url: '/giftingorderblessing',
    method: 'delete',
    params: query
  })
}

// 修改分组状态
export function getGiftingorderblessingGroupStatus(query) {
  return fetch({
    url: '/giftingorderblessing/group/status',
    method: 'put',
    data: query
  })
}

// 获取祝福语分组详情
export function giftingorderblessingGroupDetail(query) {
  return fetch({
    url: '/giftingorderblessing/group/detail',
    method: 'get',
    params: query
  })
}

// 修改送礼商品的启用状态
export function giftingordergoodsStatus(query) {
  return fetch({
    url: '/giftingordergoods/status',
    method: 'put',
    data: query
  })
}






